





































































































































































































import { Component, Vue, Prop, Inject, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState('RiskProfileItem', {
      riskProfileItems: 'riskProfileItems',
    }),
    ...mapState('QuestionGroup', {
      questionGroup: 'questionGroup',
    }),
    ...mapState('Question', {
      question: 'question',
    }),
    ...mapState('CandidateProfile', {
      candidateProfileItems: 'candidateProfileItems',
    }),
  },
})
export default class QuestionConditionFormFields extends Vue {
  @Prop() value!: QQuestionCondition;
  @Prop() readonly questions!: BridgeModel[];
  @Prop({
    default: () => {
      return [
        {
          label: 'Question',
          value: 'question',
        },
        {
          label: 'Candidate Profile',
          value: 'profile_data',
        },
        {
          label: 'Others',
          value: 'others',
        },
      ];
    },
  })
  readonly sourceTypes!: Record<string, string>[];
  @Inject('hasNoRpi') readonly noRpi!: boolean;

  question!: Question;
  questionGroup!: QuestionGroup;
  candidateProfileItems!: { compute: Model[]; standard: Model[] };

  operators = [
    {
      label: 'Any',
      value: 'any',
    },
    {
      label: 'Equals',
      value: 'equals',
    },
    {
      label: 'Not Equals',
      value: 'not_equals',
    },
    {
      label: 'Includes',
      value: 'includes',
    },
    {
      label: 'Not Includes',
      value: 'not_includes',
    },
  ];

  advanceOperators = [
    {
      label: 'Greater Than',
      value: 'greater_than',
    },
    {
      label: 'Greater Than or Equal To',
      value: 'greater_than_or_equal_to',
    },
    {
      label: 'Less Than',
      value: 'less_than',
    },
    {
      label: 'Less Than or Equal To',
      value: 'less_than_or_equal_to',
    },
  ];

  questionOperators = [
    {
      label: 'Retrieve Value',
      value: 'retrieve_value',
    },
  ];

  isForMultipleMatchingValue = false;

  @Watch('item', { immediate: true, deep: true })
  watchChanges() {
    this.isForMultipleMatchingValue = !(
      this.isSingleSelectType &&
      ['', 'equals', 'not_equals'].includes(this.item.matching_operator)
    );
  }

  get item() {
    return this.value;
  }
  set item(v) {
    this.value = v;
  }

  get isSingleSelectType() {
    const singleSelectType = [
      'radiobutton',
      'dropdown_single',
      'body_parts',
      'country',
      'state',
    ];
    return (
      singleSelectType.includes(
        this.selectedCandidateProfileItem?.question?.form_type
      ) || singleSelectType.includes(this.selectedQuestion?.form_type)
    );
  }

  get isNotRetrieveValue() {
    return this.item.matching_operator !== 'retrieve_value';
  }

  get selectedQuestion(): Model | null {
    if (!this.questionGroup.library && !this.questions) {
      return null;
    }

    const questionList = this.questions ?? this.questionGroup.library;
    const bridgeModel: BridgeModel | undefined = questionList.find(
      (item: BridgeModel) => item.bridge.object_id === this.item.source_oid
    );

    if (!bridgeModel) {
      return null;
    }

    return bridgeModel['bridge'];
  }

  get selectedCandidateProfileItem(): Model | null {
    if (this.item.source_type !== 'profile_data') {
      return null;
    }

    return (
      this.localCandidateProfileItems.find(
        (cq) => cq.key === this.item.source_key
      ) || null
    );
  }

  get localCandidateProfileItems() {
    const computedCandidateProfileItems = this.candidateProfileItems.compute;
    const standardCandidateProfileItems = this.candidateProfileItems.standard.flatMap(
      (i) => i.items
    );
    return [...computedCandidateProfileItems, ...standardCandidateProfileItems];
  }

  get isSourceTypeQuestion() {
    // If the source type is question and the selected question is not null
    if (this.item.source_type === 'question' && this.selectedQuestion) {
      // Check whether the answer options is empty or not
      return !!this.selectedQuestion.answer_options.length;
    }
    return false;
  }

  get isSourceTypeProfile() {
    // If the source type is profile_data and the selected profile item is not null
    if (
      this.item.source_type === 'profile_data' &&
      this.selectedCandidateProfileItem
    ) {
      if (!this.selectedCandidateProfileItem.question) {
        return false;
      }
      // Check whether the answer options is empty or not
      return !!this.selectedCandidateProfileItem.question.answer_options.length;
    }
    return false;
  }

  get localSourceTypes() {
    const defaultTypes = this.sourceTypes;
    if (!this.noRpi && !this.questionGroup.is_for_candidate_profile) {
      defaultTypes.push({
        label: 'Risk Profile',
        value: 'risk_profile',
      });
    }
    return defaultTypes;
  }

  get riskProfileItemSourceKeys() {
    return [
      {
        label: 'Is Enabled',
        value: 'is_enabled',
      },
      {
        label: 'Extra Form Value',
        value: 'extform_value',
      },
      {
        label: 'How Often',
        value: 'how_often',
      },
    ];
  }

  get localQuestions() {
    if (this.questions) {
      return this.questions;
    }

    if (!this.questionGroup.library) {
      return null;
    }
    return this.questionGroup.library;
  }

  getOperators(sourceType) {
    const defaultOperators = [...this.operators, ...this.advanceOperators];
    if (sourceType === 'question') {
      return [...defaultOperators, ...this.questionOperators];
    }
    return defaultOperators;
  }

  changeSourceType() {
    this.item.source_oid = '';
  }

  getQuestionItemText(item) {
    return this.$options.filters?.escapeHtml(item.bridge.body);
  }

  clearMatchingValue() {
    this.item.matching_value = '';
  }

  customFilter(item, queryText) {
    return (
      item.bridge.body.includes(queryText) ||
      (item.bridge.internal_annotation &&
        item.bridge.internal_annotation.includes(queryText))
    );
  }

  isInternalAnnotationExisted(question) {
    if (!question) {
      return false;
    }

    if (!question.internal_annotation) {
      return false;
    }

    if (!question.internal_annotation.length) {
      return false;
    }

    return true;
  }
}
